<template>
    <div class="d-flex gap-3 side-nav-padding justify-content-end">
        <color-picker class="limit-width" v-model="imageEditor.bg_color" @input="handleInput"></color-picker>
    </div>
</template>

<script>

import { useImageEditorStore } from '../store';
import {functions} from "../imageEditor";

export default {
    setup() {
        const store = useImageEditorStore();

        return {
            imageEditor: store,
        }
    },
    methods: {
        handleInput () {
            functions.updateBackground();
        }
    }
}
</script>

<style lang="scss" scoped>
    @use "Themes/Storefront/resources/assets/public/sass/utils/_variables.scss" as var;

    @media (min-width: var.$breakpoint-lg) {
        .limit-width {
            max-width: 272px; //270+2
        }
    }
</style>
